module.exports = "/images/no-photo.svg";